import { Tag } from '@components/tag';

import { TravellerJourneyListItem } from 'api/types';

import { statusTagMap, statusLabelMap } from '../constants';

export const StatusCell = ({ row: traveller }: { row: TravellerJourneyListItem }) => {
  return (
    <Tag
      text={statusLabelMap[traveller.status]}
      variant={statusTagMap[traveller.status]}
      size="small"
    />
  );
};
